
$(function () {
    const body = $('body');
    const nav = $('.nav');
    const burger = $('.burger');
    const break_point = 992;
    const nav_window = $('<div class="navwindow"></div>');
    const nav_wrap = $('.navwrap');
    const submenu_nav = $('.subnav-dropdown');

    body.append(nav_window);

    const nav_reset = function () {
        burger.removeClass('__active');
        nav_window.hide();
        nav_window.css('pointer-events', 'none');
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        nav.find('[aria-expanded="true"]').attr('aria-expanded', 'false');
        body.removeClass('__blur');
    };

    const nav_launch = function () {
        nav_window.show();
        nav_window.css('pointer-events', 'auto');
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            if (window.innerWidth < break_point) {
                nav_reset();
                burger.focus();
            } else {
                nav.find('.__active').removeClass('__active');
                nav.find('[aria-expanded="true"]').attr('aria-expanded', 'false');
                body.removeClass('__blur');
            }
        }
    });

    nav_window.on('click.menuBase', function () {
        nav_reset();
    });

    burger.on('click.menuBase', function (event) {
        event.preventDefault();

        $(this).toggleClass('__active');

        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    function isTouchDevice() {
        return globalThis.matchMedia('(pointer: coarse)').matches;
    }

    function initMenu() {
        const browser_width = window.innerWidth;
        const nav_trigger = nav.find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');

        nav_trigger.off('click.menu');
        $(document).off('click.menu');
        $('.navwrap ul').off('mouseenter.menu focusin.menu');
        $('.menu-item-has-children > a').off('click.menu');
        $('.backto').off('click.menu');
        $('.backto button').off('click.menu');
        $('.viewall').off('click.menu');

        $('.navwrap ul').on('mouseenter.menu focusin.menu', function () {
            $('.navwrap ul').each(function () {
                const elem = $(this);
                const rect = elem[0].getBoundingClientRect();

                if (rect.x + rect.width > window.innerWidth) {
                    elem.addClass('left');
                }
            });
        });

        if (browser_width >= break_point) {
            nav.find('a, button').removeAttr('tabindex');

            nav_trigger.on('click.menu', function (event) {
                if (!$(this).is('button')) {
                    return;
                }

                event.preventDefault();

                const parent = $(this).parent();

                parent.siblings().removeClass('__active');
                parent.siblings().find('.__active').removeClass('__active');
                parent.siblings().find('[aria-expanded="true"]').attr('aria-expanded', 'false');

                parent.toggleClass('__active');

                $(this).attr('aria-expanded', parent.hasClass('__active') ? 'true' : 'false');

                if (!parent.hasClass('__active')) {
                    parent.find('.__active').removeClass('__active');
                    parent.find('[aria-expanded="true"]').attr('aria-expanded', 'false');
                }
            });

            $(document).on('click.menu', function (event) {
                if ($(event.target).closest('[data-primary-menu]').length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', 'false');
                    body.removeClass('__blur');
                }
            });

            nav_reset();
        }

        if (browser_width < break_point) {
            nav.find('a, button').attr('tabindex', '-1');

            nav_trigger.on('click.menu', function (event) {
                event.stopPropagation();

                if ($(this).parent().children('ul').length > 0) {
                    event.preventDefault();

                    $(this).parent().children('ul').addClass('__active');
                    $(this).parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            $('.menu-item-has-children > a').on('click.menu', function (event) {
                event.preventDefault();
            });

            $('.backto').on('click.menu', function (event) {
                event.preventDefault();
                event.stopPropagation();

                $(this).parents('li').parent('ul').addClass('__active');
                $(this).parents('li').children('a').focus();
            });
        }

        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.on('click.menu', function (event) {
                event.stopPropagation();

                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }

        $('.viewall').on('click.menu', function (event) {
            event.stopPropagation();
        });

        $('.backto button').on('click.menu', function (event) {
            event.preventDefault();
            event.stopPropagation();

            $(this).closest('.__active').removeClass('__active');
        });
    }

    function initSubMenuDropdown() {
        if (!submenu_nav.length) {
            return;
        }

        const is_mobile_submenu = window.innerWidth < break_point;
        const submenu_mobile_controls = submenu_nav.children('.subnav-dropdown__mobile-control');
        const submenu_mobile_toggles = submenu_nav.children('.subnav-dropdown__mobile-toggle');
        const submenu_items = submenu_nav.find('.subnav-dropdown__item--has-children');
        const submenu_buttons = submenu_items.children('.subnav-dropdown__toggle');

        const setSubmenuItemState = function (item, is_open) {
            item.toggleClass('subnav-dropdown__item--focus', is_open && !is_mobile_submenu);
            item.toggleClass('subnav-dropdown__item--open', is_open);
            item.children('.subnav-dropdown__toggle').attr('aria-expanded', is_open ? 'true' : 'false');
        };

        submenu_nav.off('.submenuDropdown');
        submenu_items.off('.submenuDropdown');
        submenu_buttons.off('.submenuDropdown');
        submenu_mobile_toggles.off('.submenuDropdown');

        if (!is_mobile_submenu) {
            submenu_nav.removeClass('subnav-dropdown--open');
            submenu_mobile_controls.prop('checked', false);
            submenu_mobile_toggles.attr('aria-expanded', 'false');
            submenu_items.removeClass('subnav-dropdown__item--open');
            submenu_buttons.attr('aria-expanded', 'false');
        } else {
            submenu_mobile_toggles.attr('aria-expanded', submenu_mobile_controls.first().is(':checked') ? 'true' : 'false');
            submenu_items.removeClass('subnav-dropdown__item--focus subnav-dropdown__item--open');
            submenu_buttons.attr('aria-expanded', 'false');
        }

        submenu_nav.on('change.submenuDropdown', '.subnav-dropdown__mobile-control', function () {
            if (!is_mobile_submenu) {
                return;
            }

            const current_submenu = $(this).closest('.subnav-dropdown');

            current_submenu.toggleClass('subnav-dropdown--open', this.checked);
            current_submenu.children('.subnav-dropdown__mobile-toggle').attr('aria-expanded', this.checked ? 'true' : 'false');
        });

        submenu_mobile_toggles.on('click.submenuDropdown', function (event) {
            if (!is_mobile_submenu) {
                return;
            }

            event.preventDefault();

            const current_submenu = $(this).closest('.subnav-dropdown');
            const current_control = current_submenu.children('.subnav-dropdown__mobile-control');

            current_control.prop('checked', !current_control.prop('checked')).trigger('change');
        });

        submenu_items.on('mouseenter.submenuDropdown', function () {
            if (is_mobile_submenu) {
                return;
            }

            setSubmenuItemState($(this), true);
        });

        submenu_items.on('mouseleave.submenuDropdown', function () {
            if (is_mobile_submenu) {
                return;
            }

            setSubmenuItemState($(this), false);
        });

        submenu_items.on('focusout.submenuDropdown', function () {
            const item = $(this);

            setTimeout(function () {
                if (!item.find(':focus').length) {
                    setSubmenuItemState(item, false);
                }
            }, 0);
        });

        submenu_buttons.on('click.submenuDropdown', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const item = $(this).parent();
            const is_open = item.hasClass('subnav-dropdown__item--open') || item.hasClass('subnav-dropdown__item--focus');

            submenu_items.not(item).each(function () {
                setSubmenuItemState($(this), false);
            });
            setSubmenuItemState(item, !is_open);
        });

        submenu_buttons.on('keydown.submenuDropdown', function (event) {
            if (event.key !== 'Enter') {
                return;
            }

            event.preventDefault();
            $(this).trigger('click');
        });
    }

    function InitMenuOnLoad() {
        if ($('.navwrap > .nav').length) {
            initMenu();
        } else {
            setTimeout(InitMenuOnLoad, 200);
        }

        initSubMenuDropdown();
    }

    InitMenuOnLoad();

    $(globalThis).on('resize.menu', function () {
        initMenu();
        initSubMenuDropdown();
    });
});
